module.exports = __webpack_public_path__ + "static/media/card-header.c98aff91.png";